/* src/app/conciliadora-main/flow-execution-monitor/flow-execution-monitor.component.scss */
:host ::ng-deep .ant-drawer-body {
  padding: 0 !important;
}
.monitor-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: #fafafa;
}
.monitor-container.fullscreen {
  background: #f0f2f5;
}
.monitor-container.with-sidebar .monitor-body {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}
.monitor-jobs-sidebar {
  width: 280px;
  flex: 0 0 280px;
  border-right: 1px solid #f0f0f0;
  background: #fff;
  overflow-y: auto;
  padding: 12px 0;
}
.monitor-jobs-sidebar .jobs-sidebar__title {
  padding: 0 16px 8px;
  font-weight: 600;
  color: #595959;
  border-bottom: 1px solid #fafafa;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.monitor-jobs-sidebar .jobs-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.monitor-jobs-sidebar .job-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 16px;
  border-bottom: 1px solid #fafafa;
  cursor: pointer;
  transition: background 0.15s ease;
}
.monitor-jobs-sidebar .job-item:hover {
  background: #f5faff;
}
.monitor-jobs-sidebar .job-item.selected {
  background: #e6f4ff;
  border-left: 3px solid #1890ff;
}
.monitor-jobs-sidebar .job-item__tag {
  align-self: flex-start;
}
.monitor-jobs-sidebar .job-item__label {
  font-weight: 500;
  font-size: 13px;
  color: #262626;
  line-height: 1.3;
  word-break: break-word;
}
.monitor-jobs-sidebar .job-item__meta {
  display: flex;
  gap: 8px;
  font-size: 11px;
  color: #8c8c8c;
}
.monitor-jobs-sidebar .job-item__strategy {
  padding: 0 6px;
  border-radius: 3px;
  background: #f5f5f5;
  color: #595959;
  font-family: monospace;
  font-size: 10px;
}
.monitor-jobs-sidebar .job-item__counters {
  display: flex;
  gap: 10px;
  font-size: 11px;
}
.monitor-jobs-sidebar .job-item__counters .ok {
  color: #52c41a;
  font-weight: 500;
}
.monitor-jobs-sidebar .job-item__counters .err {
  color: #f5222d;
  font-weight: 500;
}
.monitor-content {
  flex: 1 1 auto;
  min-width: 0;
  overflow-y: auto;
}
.aggregate-summary {
  display: block;
  font-size: 11px;
  color: #8c8c8c;
  margin-top: 2px;
  font-weight: normal;
}
.monitor-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  padding: 16px 20px 12px;
  flex: 0 0 auto;
}
.monitor-header__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.monitor-header__title {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
}
.monitor-header__title h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.monitor-header__icon {
  color: #1890ff;
  font-size: 18px;
}
.monitor-header__actions {
  display: flex;
  gap: 4px;
}
.monitor-header__meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  flex-wrap: wrap;
  font-size: 12px;
  color: #595959;
}
.monitor-header__meta .status-tag {
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.monitor-header__meta .elapsed {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-variant-numeric: tabular-nums;
  color: #595959;
}
.monitor-header__meta .idconf {
  color: #8c8c8c;
  font-family:
    "SF Mono",
    Consolas,
    monospace;
}
.monitor-header__meta .action-tag {
  padding: 1px 8px;
  background: #f0f5ff;
  color: #1890ff;
  border-radius: 4px;
  font-weight: 500;
  font-size: 11px;
  letter-spacing: 0.3px;
}
.monitor-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 16px 20px 0;
  flex: 0 0 auto;
}
.monitor-stats .stat-card {
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  padding: 12px;
  text-align: center;
}
.monitor-stats .stat-card__label {
  font-size: 11px;
  color: #8c8c8c;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}
.monitor-stats .stat-card__value {
  font-size: 22px;
  font-weight: 600;
  color: #262626;
}
.monitor-stats .stat-card.has-error .stat-card__value {
  color: #ff4d4f;
}
.running-banner {
  margin: 16px 20px 0;
  padding: 16px;
  background: #ffffff;
  border: 1px solid #e6f7ff;
  border-radius: 6px;
  text-align: center;
  flex: 0 0 auto;
}
.running-banner ::ng-deep .ant-progress {
  margin-bottom: 12px;
}
.running-banner .phase-message {
  margin: 0;
  color: #262626;
  font-weight: 500;
  font-size: 14px;
}
.running-banner .phase-hint {
  margin: 4px 0 0;
  color: #8c8c8c;
  font-size: 12px;
}
.error-banner {
  margin: 16px 20px 0;
  flex: 0 0 auto;
}
.steps-section {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  padding: 0 20px;
}
.steps-section h4 {
  margin: 0 0 12px;
  font-size: 14px;
  color: #262626;
  display: flex;
  align-items: center;
  gap: 6px;
}
.steps-section h4 span[nz-icon] {
  color: #1890ff;
}
.steps-timeline {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding-right: 4px;
}
.steps-timeline .step-item {
  display: flex;
  gap: 12px;
  padding: 10px 12px;
  margin-bottom: 6px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 120ms, border-color 120ms;
  outline: none;
}
.steps-timeline .step-item:hover {
  background: #f5faff;
  border-color: #91d5ff;
}
.steps-timeline .step-item:focus-visible {
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}
.steps-timeline .step-item.selected {
  background: #e6f7ff;
  border-color: #1890ff;
}
.steps-timeline .step-item.has-error {
  border-left: 3px solid #ff4d4f;
}
.steps-timeline .step-bullet {
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 12px;
}
.steps-timeline .step-bullet.success {
  background: #52c41a;
}
.steps-timeline .step-bullet.error {
  background: #ff4d4f;
}
.steps-timeline .step-content {
  flex: 1 1 auto;
  min-width: 0;
}
.steps-timeline .step-title {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.steps-timeline .step-title strong {
  font-size: 13px;
  color: #262626;
}
.steps-timeline .step-title small {
  color: #8c8c8c;
  font-size: 11px;
}
.steps-timeline .step-meta {
  display: flex;
  gap: 12px;
  margin-top: 2px;
  font-size: 11px;
  color: #8c8c8c;
  font-variant-numeric: tabular-nums;
}
.steps-timeline .step-error-message {
  margin-top: 4px;
  color: #cf1322;
  font-size: 11px;
  background: #fff1f0;
  padding: 4px 8px;
  border-radius: 4px;
}
.step-detail {
  flex: 0 0 auto;
  margin: 12px 20px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  padding: 12px;
}
.step-detail h4 {
  margin: 0 0 8px;
  font-size: 13px;
  color: #262626;
  display: flex;
  align-items: center;
  gap: 6px;
}
.step-detail h4 span[nz-icon] {
  color: #1890ff;
}
.step-detail .json-block {
  margin: 0;
  padding: 8px;
  background: #fafafa;
  border-radius: 4px;
  font-family:
    "SF Mono",
    Consolas,
    monospace;
  font-size: 11px;
  line-height: 1.5;
  color: #595959;
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 240px;
  overflow-y: auto;
}
.step-detail ::ng-deep .ant-collapse-content-box {
  padding: 8px !important;
}
.empty-result {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}
.monitor-footer {
  flex: 0 0 auto;
  padding: 12px 20px;
  background: #ffffff;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  position: sticky;
  bottom: 0;
}
.monitor-footer button + button {
  margin-left: 0;
}
.monitor-container.fullscreen .monitor-stats {
  grid-template-columns: repeat(6, 1fr);
}
.monitor-container.fullscreen .steps-timeline .step-item {
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
}
/*# sourceMappingURL=flow-execution-monitor.component.css.map */
